export const refinementItem = `
  <label class="text-gray-800 flex text-sm items-start justify-start cursor-pointer">
    <div class="flex items-start">
        <input type="checkbox" class="mt-px h-5 w-5 border-gray-300 focus:ring-2" {{#isRefined}}checked="true"{{/isRefined}}>
        <span class="ml-2">{{label}}</span>
    </div>
    <span class="mt-px text-2xs bg-navy-50/30 rounded-full leading-none px-2 py-1 text-navy-600 ml-2">{{count}}</span>
  </label>
`

export const refinementClasses = {
  item: ['cursor-pointer'],
  noRefinementRoot: 's-no-results',
  list: ['space-y-3 mb-6 -mt-1'],
}
